export default __webpack_public_path__ + "static/mobile_dock-9e023a4d1be4c5aca9ce26d0a3263b89.png";